import React from "react";
import { useHideElement } from "../../hooks/useHideElement";
import { useOverrideStyles } from "../../hooks/useOverrideStyles";
import styled from "styled-components";
import { fonts, MoreTheme, OlympiacosTheme, PaobcTheme } from "./mixins";
import Button from "./Button";
import warning from "../../assets/images/warning-3d.png";
import useMiniSite from "../../hooks/useMiniSite.js";

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--errorPageBg);
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
  padding: 16px 24px 24px 24px;
`;

const Title = styled.h1`
  ${fonts.smallTitle()}
  margin: 0;
  padding-top: 8px;
`;

const Message = styled.p`
  ${fonts.normalTextSmall()}
  margin: 0;
`;

interface ErrorPageProps {
  onRetry?: () => void;
}

export function ErrorPage({ onRetry }: ErrorPageProps) {
  const { isOlympiacos, isPaoBC } = useMiniSite();
  const r = window.ticketreservation_resources;
  const title = r?.SomethingWrong ?? "Oops! Something went wrong.";
  const message =
    r?.SomethingWrongText ??
    "Try again in a few seconds or check your connection.";
  const retryLabel = r?.TryAgain ?? "Try again";

  useHideElement("footer2");
  useOverrideStyles("html", { overflow: "hidden" });
  useOverrideStyles("body", { overflow: "hidden" });
  useOverrideStyles("#ui-wrap", {
    overflow: "hidden",
    height: "100vh",
    paddingTop: "0",
  });
  useOverrideStyles("#main-wrapper", { padding: "0", marginBottom: "0" });
  useOverrideStyles(".homepage .inner", { maxWidth: "100%", padding: "0" });

  return (
    <>
      {isOlympiacos ? <OlympiacosTheme /> : <MoreTheme />}
      {isPaoBC && <PaobcTheme />}
      <Container>
        <Content>
          <div>
            <img src={warning} alt="warning" width={80} height={80} />
            <Title>{title}</Title>
            <Message>{message}</Message>
          </div>

          {onRetry && (
            <Button
              type="button"
              variant="primary"
              text={retryLabel}
              onClick={onRetry}
              width="160px"
              height="48px"
            />
          )}
        </Content>
      </Container>
    </>
  );
}
